import { I18N } from '@/app'
import { createForm, yup } from '@codeleap/common'

export const aboutYouForm = () => {
  return createForm('aboutYou', {
    gender: {
      label: I18N.t('form.label.gender'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      type: 'select',
      validate: yup.string().required(),
      'aria-label': I18N.t('form.label.gender'),
      'aria-required': true
    },
    country: {
      label: I18N.t('form.label.country'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      type: 'select',
      validate: yup.string().required(),
      'aria-label': I18N.t('form.label.country'),
      'aria-required': true
    },
    inbound_source: {
      type: 'select',
      label: I18N.t('form.label.inboundSource'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      validate: yup.string().nullable(),
      'aria-label': I18N.t('form.label.inboundSource'),
      'aria-required': true
    },
    inbound_source_details: {
      type: 'text',
      label: I18N.t('form.label.inboundSourceDetails'),
      placeholder: I18N.t('form.placeholder.inboundSourceDetails')
    },
    climate_priority: {
      type: 'select',
      label: I18N.t('form.label.climate_priority'),
      placeholder: I18N.t('form.placeholder.climate_priority'),
      validate: yup.string().required()
    },
    satisfaction_at_work: {
      type: 'slider',
      defaultValue: 3,
      label: I18N.t('form.label.satisfaction_at_work'),
      componentProps: {
        trackMarks: {
          1: I18N.t('form.label.satisfaction_at_work_track_1'),
          5: I18N.t('form.label.satisfaction_at_work_track_5')
        },
        trackMarkStyle: {
          fontSize: 14,
          color: '#130A09',
          fontWeight: 400
        }
      },
      min: 1,
      max: 5
    },
    learning_motivations: {
      label: 'What are you looking to achieve by learning?',
      placeholder: 'Select an option',
      type: 'select'
    },
    confidence_at_work: {
      type: 'slider',
      defaultValue: 3,
      label: 'How confident are you in your ability to act on climate at work?',
      componentProps: {
        trackMarks: {
          1: I18N.t('form.label.confidence_at_work_track_1'),
          5: I18N.t('form.label.confidence_at_work_track_5')
        },
        trackMarkStyle: {
          fontSize: 14,
          color: '#130A09',
          fontWeight: 400
        }
      },
      min: 1,
      max: 5
    }
  })
}
